<template>
  <v-card>
    <v-card-title class="headline grey lighten-2">Reason</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-textarea
            rows="3"
            outlined
            placeholder="Write here ..."
            hide-details
            v-model="reason"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="$emit('close')">Cancel</v-btn>
      <v-btn color="success" @click="submit">Submit</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reason: "",
    };
  },
  methods: {
    submit() {
      if (this.isRequired && this.reason == "") {
        this.$swal("Please enter valid reason");
        return;
      }
      this.$emit("submit", this.reason);
    },
  },
};
</script>
